{
  "title": "Management",
  "title_Agrifirm": "Management",
  "title_Agravis": "Avidata Management",
  "home": "Home",
  "app": {
    "no_results_title": "Geen resultaten",
    "no_results_description": "Er zijn geen resultaten gevonden.",
    "customer": {
      "module": "Klantenbeheer",
      "search": {
        "placeholder": "Zoek klant"
      },
      "customer": "Klanten",
      "add-customer": "Klant toevoegen",
      "edit-customer": "Klant informatie wijzigen",
      "navigation": {
        "details": "Details",
        "locations": "Locaties"
      },
      "detail": {
        "add_location": "Locatie toevoegen aan klant: ",
        "edit_location": "Locatie wijzigen van klant: ",
        "title_general": "Algemeen",
        "title_address": "Adresgegevens",
        "title_contact": "Contactgegevens",
        "id": "ID",
        "name": "Naam",
        "location_type": "Locatie Type",
        "email_address": "Emailadres",
        "street": "Straat",
        "postal_code": "Postcode",
        "house_number": "Huisnummer",
        "house_number_addition": "Huisnummer toevoeging",
        "city": "Stad",
        "country": "Land",
        "phone_number": "Telefoonnummer",
        "mobile_number": "Mobiel nummer"
      },
      "confirmmsg": {
        "delete_item_location": "Wilt u deze locatie verwijderen?",
        "delete_item_customer": "Wilt u deze klant verwijderen?"
      }
    },
    "contactperson": {
      "module": "Contactpersoonbeheer",
      "search": {
        "placeholder": "Zoek contactpersoon"
      },
      "contactperson": "Contactpersoon",
      "contactpersons": "Contactpersonen",
      "add-contactperson": "Contactpersoon toevoegen",
      "edit-contactperson": "Informatie wijzigen van contactpersoon",
      "navigation": {
        "details": "Details",
        "authorizations": "Rechten",
        "relations": "Klantrelaties"
      },
      "has_relation_label": "relatie",
      "all_locations_relation_label": "Alle locaties hebben een relatie met deze contactpersoon",
      "detail": {
        "location_page_title": "Locatie wijzigen voor contactpersoon ",
        "title_general": "Algemeen",
        "title_address": "Adresgegevens",
        "title_contact": "Contactgegevens",
        "id": "ID",
        "first_name": "Voornaam",
        "last_name": "Achternaam",
        "location_type": "Locatie Type",
        "email_address": "Emailadres",
        "street": "Straat",
        "postal_code": "Postcode",
        "house_number": "Huisnummer",
        "house_number_addition": "Huisnummer toevoeging",
        "city": "Stad",
        "country": "Land",
        "phone_number": "Telefoonnummer",
        "mobile_number": "Mobiel nummer"
      },
      "relations": {
        "location_detail_page_title": "Vastleggen relaties voor contactpersoon",
        "title_search_customer": "Selecteer de klant waarmee u een relatie wilt vastleggen",
        "title_select_location": "Selecteer de locatie van deze klant waarmee u een relatie wilt vastleggen"
      },
      "confirmmsg": {
        "delete_item_location": "Wilt u deze locatie verwijderen?",
        "delete_item_contactperson": "Wilt u deze contactpersoon verwijderen?"
      },
      "authorization": {
        "add_applicationgroup": "Applicatiegroep toevoegen",
        "contactperson_employee_not_found": "Autorisaties voor de contactpersoon konden niet worden gevonden. Dit kan komen, doordat de contactpersoon meerdere malen voorkomt."
      }
    },
    "employee": {
      "module": "Medewerkerbeheer",
      "edit-employee": "Wijzig medewerkergegevens",
      "search": {
        "placeholder": "Selecteer medewerker"
      },
      "employees": "Medewerkers",
      "navigation": {
        "details": "Details",
        "relations": "Klantrelaties"
      },
      "detail": {
        "title_general": "Algemeen",
        "title_contact": "Contactgegevens",
        "user_name": "Gebruikersnaam",
        "first_name": "Voornaam",
        "last_name": "Achternaam",
        "email": "Emailadres",
        "mobile_number": "Mobiel nummer",
        "status": "Status",
        "active": "Actief",
        "inactive": "Inactief"
      },
      "relations": {
        "add_relation": "Medewerkerrelatie toevoegen",
        "back_to_relations": "Terug naar relaties",
        "all_locations_relation_label": "Autorisatie op klantniveau",
        "customer_relation": "Autorisatie op klantniveau",
        "shipto_relation": "locatie-autorisatie(s)",
        "has_relation_label": "relatie",
        "no_relation": "Geen relatie",
        "no_relations_found": "Er zijn nog geen klantrelaties gevonden voor deze medewerker.",
        "relationship_type": "Relatietype",
        "select_customer": "Selecteer klant",
        "title_search_customer": "Selecteer de klant waarmee u een relatie wilt vastleggen",
        "title_select_location": "Selecteer de locatie van deze klant waarmee u een relatie wilt vastleggen"
      }
    },
    "errormsg": {
      "not_found": "De gegevens konden niet worden gevonden.",
      "not_loaded": "De gegevens konden niet worden geladen.",
      "mandatory_form_field": "Dit veld is verplicht.",
      "email_pattern": "Voldoet niet aan email formaat."
    },
    "successmsg": {
      "upsert_success": "Succesvol opgeslagen.",
      "delete_success": "Het item is verwijderd."
    },
    "countries": {
      "NL": "Nederland",
      "BE": "België",
      "GB": "Groot-Brittanië",
      "FR": "Frankrijk",
      "PL": "Polen",
      "UA": "Oekraïne",
      "ES": "Spanje",
      "JO": "Jordanië",
      "HU": "Hongarije",
      "NG": "Nigeria",
      "FI": "Finland",
      "CN": "China",
      "JM": "Jamaica",
      "TZ": "Tanzania",
      "KE": "Kenia",
      "UG": "Oeganda",
      "DE": "Duitsland"
    }
  }
}
